import Button from '@/components/basicComponents/button';
import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import guid from '@/shared/utils/guid';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';
import { InvestorEntitiesRowStatus } from '../../../investorEntitiesRowStatus';
import { IHouseholdComparison, TypeWindow } from '../../../types';
import { columns } from '../constants';

interface MobileTableProps {
  tableData: IHouseholdComparison[];
  openInvestorImportDetailPage: (type: TypeWindow, row: IHouseholdComparison) => void;
}

const MobileTable = ({ tableData, openInvestorImportDetailPage }: MobileTableProps) => {
  const TableRow = ({ el }: { el: IHouseholdComparison }) => {
    return (
      <MobileTableRowWrap key={guid()}>
        <MobileRow>
          <MobileRowTitle>{columns[0].title}</MobileRowTitle>
          <MobileRowValue>{el.householdName}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[1].title}</MobileRowTitle>
          <MobileRowValue>{el.totalEntities}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[2].title}</MobileRowTitle>
          <MobileRowValue>{el.entitiesAdded}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[3].title}</MobileRowTitle>
          <MobileRowValue>{el.entitiesRemoved}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[4].title}</MobileRowTitle>
          <MobileRowValue>
            {el.advisorEmail.toLowerCase() === 'multiple' ? <MultipleText>Multiple</MultipleText> : <>{el.advisorEmail}</>}
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[5].title}</MobileRowTitle>
          <MobileRowValue>
            <InvestorEntitiesRowStatus status={el.status} />
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[6].title}</MobileRowTitle>
          <MobileRowValue>
            <Button size="sm" onClick={() => openInvestorImportDetailPage('investorImportDetail', el)}>
              View
            </Button>
          </MobileRowValue>
        </MobileRow>
      </MobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {tableData.length ? (
        tableData.map((el: any, index: number) => {
          return <TableRow el={el} key={index} />;
        })
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default MobileTable;

const MultipleText = styled.span`
  color: ${themeVar('context.error')};
`;
